module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-faq",
    attrs: {
      "block": "lightest"
    }
  }, [_c('div', {
    staticClass: "home-faq__inner group group--first-last"
  }, [_c('h2', {
    staticClass: "h2 heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.faqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "home-faq__block"
    }, [_c('h4', {
      staticClass: "h4 heading home-faq__question"
    }, [_vm._v(_vm._s(faq.question))]), _vm._v(" "), _c('p', {
      staticClass: "p faq__answer"
    }, [_vm._v(" " + _vm._s(faq.answer))])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2071da5e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Faqs.vue
// module id = 235
// module chunks = 0